var map = {
	"./cloud-wan-table-en.svg": "nWfU",
	"./cloud-wan-table-m-en.svg": "AqDS",
	"./cloud-wan-table-m-zh.svg": "Oc3k",
	"./cloud-wan-table-zh.svg": "3YgB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UNDY";